import MyAccountSection from '../MyAccountSection/MyAccountSection';
import { MyAccountSectionProps } from '../MyAccountSection/type/propsTypes';
import styles from './MyAccountContainer.module.scss';
import { MyAccountContainerProps } from './type/propsTypes';

const MyAccountContainer = (props: MyAccountContainerProps) => (
  <div className={styles['user-account-container']} data-testid="user-account-container-testid">
    {props.userData?.map((sectionData: MyAccountSectionProps) => (
      <MyAccountSection
        sectionData={sectionData.sectionData}
        key={sectionData.sectionData.title}
        isExclamation={props.isRenewalUrgent ?? false}
      />
    ))}
  </div>
);
export default MyAccountContainer;
export type { MyAccountContainerProps };
